import { axiosApi } from "./helper";

export const getNewsletterCampaigns = () => {
  return axiosApi("campaigns");
};

export const updateNewsletterCampaignConsent = (id, consent) => {
  return axiosApi(`campaigns/${id}/me`, { consent }, "PUT");
};
